import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FileManagerService } from '@app/core/services/file-manager/file-manager.service';
import { FilesService } from '@app/core/services/files/files.service';
import { fileUploadToImageFile, ImageFile } from '@app/shared/models/file-manager/image-file';
import { forkJoin, map, Observable, of, Subscription, switchMap } from 'rxjs';
import { FileTypes } from "@shared/constants/file-manager/file-upload-options";
import { ActiveComponentService } from "@services/component/active-component.service";

@Component({
  selector: 'app-image-manager',
  templateUrl: './image-manager.component.html',
  styleUrls: ['./image-manager.component.css']
})
export class ImageManagerComponent implements OnInit, OnDestroy {
  @Input() showImageManager: boolean = true;

  selectedImageFiles: ImageFile[] = [];
  private subscription: Subscription = new Subscription();

  constructor(
    private fileManagerService: FileManagerService,
    private filesService: FilesService,
    private activeComponentService: ActiveComponentService
  ) {

  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  ngOnInit(): void {
    let isActiveComponentSet = false;
    const selectedFilesSubscription = this.fileManagerService.selectedFiles$.pipe(
      switchMap(files => {
        const currentImageFiles = new Set(this.selectedImageFiles.map(thumbnail => thumbnail.id));
        const newImageFiles = new Set(files.map(file => file.id!));

        this.selectedImageFiles = this.selectedImageFiles.filter(thumbnail => newImageFiles.has(thumbnail.id!));
        const fetchImageFiles$ = Array.from(newImageFiles)
          .filter(fileId => !currentImageFiles.has(fileId))
          .map(fileId => this.getImageFile(fileId));
        return fetchImageFiles$.length > 0 ? forkJoin(fetchImageFiles$) : of([]);
      })
    ).subscribe(imageFiles => {
      imageFiles.forEach(imageFile => {
        if (imageFile) {
          this.selectedImageFiles.push(imageFile);
          isActiveComponentSet = this.setActiveComponentOnce(isActiveComponentSet);
        }
      });
    });

    this.subscription.add(selectedFilesSubscription);
  }

  getImageFile(fileId: string): Observable<ImageFile | null> {
    return this.filesService.get(fileId).pipe(
      map(fileUpload => {
        if (fileUpload.url && Object.values(FileTypes["IMAGE"]).includes(fileUpload.fileType!.toUpperCase())) {
          return fileUploadToImageFile(fileUpload);
        }
        return null;
      })
    );
  }

  removeImageFile($event: string): void {
    this.fileManagerService.removeSelectedFile($event);
    this.fileManagerService.removeUploadedFile($event);
  }

  private setActiveComponentOnce(isActiveComponentSet: boolean): boolean {
    if (!isActiveComponentSet) {
      this.activeComponentService.setActiveComponent('app-image-manager');
      return true;
    }
    return isActiveComponentSet;
  }
}

